import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { enableArrayMethods } from 'immer';
import { debounce } from 'lodash-es';
import config from 'styles/config.module.scss';

// https://immerjs.github.io/immer/array-methods/
enableArrayMethods();

const mobileWidth = Number(config.mobileWidth);
const isMobile = () => mobileWidth > window.innerWidth;

const isTouchDevice =
  !!(
    (
      typeof window !== 'undefined' &&
      ('ontouchstart' in window ||
        // @ts-expect-error polyfill for old browsers
        (window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch))
    )
    // @ts-expect-error polyfill for old browsers
  ) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));

export type State = {
  isTouchDevice: boolean;
  isMobile: boolean;
  canvasAspect: number;
  setIsMobile: () => void;
  setCanvasAspect: (aspect: number) => void;
};

export const useApplicationStore = create<State>()(
  subscribeWithSelector(
    immer((set) => ({
      isTouchDevice,
      isMobile: isMobile(),
      canvasAspect: 1,
      setIsMobile: () =>
        set((state) => {
          state.isMobile = isMobile();
        }),
      setCanvasAspect: (aspectRatio) =>
        set((state) => {
          state.canvasAspect = aspectRatio;
        }),
    }))
  )
);

const onResize = () => useApplicationStore.getState().setIsMobile();
window.addEventListener('resize', debounce(onResize, 100));
